module.exports = __webpack_public_path__ + "static/media/IMG_1642.b8af4650.JPG";